import { ContactPage } from "@web/components/LandingPage/ContactPage/ContactPage"
import { LandingLayout } from "@web/components/LandingPage/LandingLayout"

const MainPage = () => {
  return (
    <LandingLayout>
      <ContactPage />
    </LandingLayout>
  )
}

export default MainPage
